


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { generateOptions } from '../summarySheetUtils';
import { exportExcelByArray } from '@/utils/other';

type IDataInfo = IReport.ISummarySheet.IDataInfo;

const moduleColumn = {
  dataIndex: 'moduleTitle',
  slots: { title: 'moduleTitle' },
  ellipsis: true,
  width: '12%',
  scopedSlots: {
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
  },
  onFilter: (value: string, record: IDataInfo) => {
    return record.moduleTitle.toString().toLowerCase().includes(value.toLowerCase());
  },
};
const settlementDateColumn = {
  dataIndex: 'settlementDate',
  slots: { title: 'settlementDateTitle' },
  scopedSlots: { customRender: 'settlementDate' },
  width: '9%',
  align: 'center',
  sorter: (a: IDataInfo, b: IDataInfo) => {
    return new Date(a.settlementDate).valueOf() - new Date(b.settlementDate).valueOf();
  },
};
const sumManDayColumn = {
  dataIndex: 'sumManDay',
  slots: { title: 'sumManDayTitle' },
  width: '8%',
  align: 'center',
  sorter: (a: IDataInfo, b: IDataInfo) => a.sumManDay - b.sumManDay,
};
const projectColumn = {
  dataIndex: 'projectName',
  slots: { title: 'projectTitle' },
  width: '6%',
};



@Component
export default class SummaryTable extends Vue {
  @Prop({required: true}) private sheetData!: IDataInfo[];
  @Prop({default: false}) private spinning!: boolean;
  private currentRow: IDataInfo | null = null;
  private currentPage = 1;
  private pagination = {
    pageSize: 15,
    hideOnSinglePage: true,
  };
  private searchInput = null;
  private searchText = '';
  private searchedColumn = '';
  private exportData: IDataInfo[] = [];
  private totalManDay = '0';
  get activeId(): string {
    return this.currentRow?.id || '';
  }
  get columns() {
    // generateKeysAndTheads方法 有用到 columns
    // 要求column 有column.slots.title、dataIndex屬性
    // 滿足 this.$t(`report.${column.slots.title.replace('Title', '')}` 的條件
    const {
      ownerOption,
      statusOption,
      creatorOption,
      settlementUnitOption,
      quotationCategoryOption,
    } = generateOptions(this.sheetData);
    const ownerColumn = {
      dataIndex: 'followName',
      slots: { title: 'ownerTitle' },
      width: '8%',
      filters: ownerOption,
      onFilter: (value: string, record: IDataInfo) => record.owner === value,
    };
    const statusColumn = {
      dataIndex: 'status',
      slots: { title: 'statusTitle' },
      width: '8%',
      align: 'center',
      filters: statusOption,
      onFilter: (value: string, record: IDataInfo) => record.status === value,
    };
    const creatorColumn = {
      dataIndex: 'createdName',
      slots: { title: 'creatorTitle' },
      width: '8%',
      filters: creatorOption,
      onFilter: (value: string, record: IDataInfo) => record.createdBy === value,
    };
    const settlementUnitColumn = {
      dataIndex: 'settlementConfigurationNames',
      slots: { title: 'settlementUnitTitle' },
      scopedSlots: { customRender: 'settlementConfigurationNames' },
      width: '8%',
      filters: settlementUnitOption,
      onFilter: (value: string, record: IDataInfo) => {
        if (record.settlementConfigurationNames.length === 0) {
          return value === 'NULL';
        }
        return record.settlementConfigurationNames.includes(value);
      },
    };
    const quotationCategoryColumn = {
      dataIndex: 'quotationCategoryNames',
      slots: { title: 'quotationCategoryTitle' },
      scopedSlots: { customRender: 'quotationCategoryNames' },
      width: '8%',
      filters: quotationCategoryOption,
      onFilter: (value: string, record: IDataInfo) => {
        if (record.quotationCategoryNames.length === 0) {
          return value === 'NULL';
        }
        return record.quotationCategoryNames.includes(value);
      },
    };
    return [
      moduleColumn,
      creatorColumn,
      ownerColumn,
      settlementDateColumn,
      projectColumn,
      quotationCategoryColumn,
      settlementUnitColumn,
      statusColumn,
      sumManDayColumn,
    ];
  }
  @Watch('sheetData')
  public watchSheetData(newValue: IDataInfo[]) {
    this.exportData = newValue;
    this.totalManDay = newValue.reduce((total, item) => total + item.sumManDay, 0).toFixed(2);
  }
  public exportExcel(dates: string[]) {
    if (this.exportData.length === 0) {
      this.$message.warning(this.$t('report.notExport').toString());
      return;
    }
    const fileName = `summary(${dates.join('To')}).xlsx`;
    const {keys, thead} = this.generateKeysAndTheads();
    const formatJson = (filterKey: string[], jsonData: IDataInfo[]) => {
      return jsonData.map((item) => {
        return filterKey.map((key) => {
          if (item[key as keyof IDataInfo] && Array.isArray(item[key as keyof IDataInfo])) {
            return item[key as keyof IDataInfo]!.toString();
          }
          return item[key as keyof IDataInfo];
        });
      });
    };
    const tbodyData = formatJson(keys, this.exportData);
    try {
      exportExcelByArray(fileName, thead, tbodyData);
    } catch (error) {
      this.$message.warning((error as Error).message);
    }
  }
  private generateKeysAndTheads() {
    const keys: string[] = [];
    const thead: string[] = [];
    this.columns.forEach((column) => {
      keys.push(column.dataIndex);
      thead.push(this.$t(`report.${column.slots.title.replace('Title', '')}`).toString());
    });
    return {
      keys,
      thead,
    };
  }
  private handleTableChange(pagination: any, filters: any, sorter: any, data: {currentDataSource: IDataInfo[]}) {
    this.currentPage = pagination.current;
    this.exportData = data.currentDataSource;
    this.totalManDay = data.currentDataSource.reduce((total, item) => total + item.sumManDay, 0).toFixed(2);
  }
  private clickRow(row: IDataInfo) {
    this.currentRow = row;
  }
  private getRowClassName(row: IDataInfo, index: number): string {
    if (row.id === this.activeId) {
      return 'active';
    }
    return '';
  }
  private customRow(row: IDataInfo, index: number) {
    return {
      on: {
        click: (event: Event) => {
          this.clickRow(row);
        },
      },
    };
  }
  private handleSearch(selectedKeys: string[], confirm: () => void, dataIndex: string) {
    confirm();
    this.searchText = selectedKeys[0];
    this.searchedColumn = dataIndex;
  }
  private handleReset(clearFilters: () => void) {
    clearFilters();
    this.searchText = '';
  }
}
